// extracted by mini-css-extract-plugin
export default {"container":"M0-z","list":"N0-z"};